'use client';

import { faDownload } from '@fortawesome/pro-light-svg-icons';
import Image from 'next/image';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { useRouter } from 'next/navigation';

import phoneMedprevApp from './assets/phone-medprev-app.png';
import { QRCodeApp } from './qr-code-app.component';

import { Button } from '@/components/ui/button/button.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { useAgendamentoNavigation } from '@/hooks/navigation/use-agendamento-navigation.hook';
import { androidAppDownloadUrl, iosAppDownloadUrl } from '@/utils/consts/download.consts';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const DownloadAppSection = () => {
  const analytics = getAnalyticsPlugin();
  const router = useRouter();
  const { buildLink } = useAgendamentoNavigation();
  const handleInstall = () => {
    analytics.track(AnalyticsEnum.CLICK_INSTALL_APP);
    const userAgent = navigator.userAgent || navigator.vendor;

    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isAndroid) {
      router.push(androidAppDownloadUrl);
      return;
    }

    if (isIOS) {
      router.push(iosAppDownloadUrl);
      return;
    }

    router.push(buildLink({ path: '/' }));
  };

  return (
    <section
      data-testid={DataTestIdEnum.CITY_DOWNLOAD_APP_SECTION}
      className="bg-green-100 xl:bg-green-200 pt-10"
    >
      <ContentContainer
        className="flex flex-col xl:flex-row xl:justify-between items-center gap-6 xl:gap-2 xl:px-12 2xl:px-18 3xl:px-32"
      >
        <Typography
          variant={TypographyVariant.LARGE_SUBTITLE}
          className="block xl:hidden font-bold text-center"
        >
          Fácil, rápido e seguro:
          {' '}
          <br />
          Agende também pelo aplicativo!
        </Typography>

        <div className="hidden xl:flex gap-4 items-center">
          <QRCodeApp />

          <div className="flex flex-col gap-2">
            <Typography
              variant={TypographyVariant.LARGE_SUBTITLE}
              className="font-bold"
            >
              Baixe o app da Medprev
            </Typography>
            <Typography>
              Fácil, rápido e seguro:
              {' '}
              <br />
              Agende também pelo aplicativo!
            </Typography>
          </div>
        </div>

        <Button
          data-testid={DataTestIdEnum.CITY_DOWNLOAD_APP_SECTION_BUTTON}
          startIcon={faDownload}
          className="flex xl:hidden h-12 w-full sm:w-75"
          onClick={handleInstall}
        >
          Instalar aplicativo
        </Button>

        <Image
          src={phoneMedprevApp}
          alt="Donwload Medprev App"
          draggable={false}
          width={280}
          height={368}
        />
      </ContentContainer>
    </section>
  );
};
